module.exports = __webpack_public_path__ + "static/media/canine.de72596d.svg";